var moduleMap = {
	"./preload/contract": () => {
		return __webpack_require__.e(/* packages_preload_contract */ 719).then(() => (() => ((__webpack_require__(682)))));
	},
	"./preload/service": () => {
		return __webpack_require__.e(/* packages_preload_service */ 418).then(() => (() => ((__webpack_require__(620)))));
	},
	"./preload/setup": () => {
		return __webpack_require__.e(/* packages_preload_setup */ 324).then(() => (() => ((__webpack_require__(641)))));
	},
	"./preload/component": () => {
		return __webpack_require__.e(/* packages_preload_component */ 866).then(() => (() => ((__webpack_require__(124)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});